export const isTokenExpired = (token) => {
  const tokenData = JSON.parse(atob(token.split(".")[1]))
  const currentTime = new Date().getTime() / 1000
  return tokenData.exp < currentTime
}
